import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  environmentProducts: null,
  environmentPenaltiesTypes: [],
  environmentRequestCategories: [],
  currentUrbanRequest: null,
  environmentRequests: null,
  currentEnvironmentPenalty: null,

  environmentPenalties: [],
  environmentPenaltiesCount: 0,
  environmentRequestsCount: 0,
  searchResults: null,
  isSearching: false,
  isLoading: false,
};

const slice = createSlice({
  name: "environment",
  initialState: initialState,
  reducers: {
    setEnvironmentState: (state, action) => {
      Object.keys(action.payload).forEach((k) => {
        state[k] = action.payload[k];
      });
    },
  },
});

export const reducer = slice.reducer;

export const setEnvironmentState = (data) => async (dispatch) => {
  dispatch(slice.actions.setEnvironmentState(data));
};
